export const LOCAL_STORAGE_KEY = 'first-point';
export const SESSION_STORAGE_KEY = 'session-point';

export const EMAIL = 'a.fedosov@andersenlab.com';

export const MEETUP_DATE = '2026-04-14';
export const MEETUP_TIME = '16:00';
export const TIME_ZONE = '(GMT +5)';
